import { Location } from "@angular/common";
import { HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.css']
})
export class AccountInfoComponent implements OnInit, OnDestroy {
paceDisplayTime: boolean = false;
userInfoSubscription:Subscription;
tabPro:String = "profile";
tabSec:String = "change-password";
tabGMAT:String = "gmat-info";
tabActive:String = "profile";
currentpwd:any = "password";
loadingCircleURL = AppSettings.loadingCircleImageURL;
dataLoaded:boolean = true;
formError:boolean = false;
userEmail:string;
fullName:string;
gcid:string;
linkedin:string;
mediaPlayerDefaultQuality:number = 0;
examType:string = '';
// examTypeOld:string = '';
testDate:Date;
targetScore:number;
targetVerbal:number;
targetQuant:number;
prevScore:number;
prevVerbal:number;
prevQuant:number;
tantativeDate:boolean;
incorrectPassword:boolean = false;
showAllCourses:boolean= true;
showMore:boolean=true;
profileTabImg:any;
securityTabimg:any;
gmatInfoImg:any;
formSuccessImg:any;
minCharacterError:boolean = false;
invalidStringError:boolean = false;
success_msg:boolean;
success_msg_gmat:boolean;
gmatDataPresent:boolean;
success_msg_pwd:boolean;
dateChange:IMyDpOptions;
pwdNotmatch:string = "Passwords do not match";
isNotSameError:boolean = false;
userCourseSubscription:any = [];
subscriptionDataLoaded:boolean = false;
courseList:any= [];
couserObjectList:any = {};
courseStatusInfo = {"Active":{'displayName':'Active','color':'#5fa406','statusIMgURL':'../../../assets/images/act.png'},
                    "Expired":{'displayName':'Expired','color':'red','statusIMgURL':'../../../assets/images/act.png'},
                    "Expiring_Soon":{'displayName':'Expiring_Soon','color':'pink','statusIMgURL':'../../../assets/images/act.png'} };

 profileForm: any;
 securityForm: any;
 gmatForm:any;
 date = new Date();
 dateplaceHolder = "dd mm yyyy";
 gfeLogo = AppSettings.cdnUrl +"assets/images/LogoGFE300.png";
 gceLogo = AppSettings.cdnUrl + "assets/images/LogoGMAT300.png";
public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd mmm yyyy',
        showTodayBtn:false,
        sunHighlight:false,
        editableDateField:false,
        disableUntil:{year: this.date.getFullYear(),
            month: this.date.getMonth()+1,
            day: this.date.getDate()},
            ariaLabelInputField:'dd mm yyyy',
            alignSelectorRight:true,
            openSelectorOnInputClick:true

    };

  constructor(private formbuilder: FormBuilder ,private route:ActivatedRoute,private location:Location, private httpClientService: HttpClientService, private sessionService: SessionService, private eventService: EventService)
  {
  	  this.profileForm = formbuilder.group({
  	  	'fullname':[this.fullName,Validators.required],
  	  	'gcid':[''],
  	  	'lnkid':['']
  	  });
      this.securityForm = formbuilder.group({
        'crpwd': ['',Validators.required],
        'newpwd':['',Validators.required],
        'cnfpwd':['',Validators.required]
      });
      this.gmatForm = formbuilder.group({
        'testdate' :['',Validators.required],
        'tentativeDate':[null],
        'targetAll': formbuilder.group({
         'targetTotal':[],
         'verbalTotal':[],
         'quantTotal':[]
        }),
        'prevoiusAll':formbuilder.group({
         'PrevTotal':[],
         'verbalPrev':[],
         'quantPrev':[]
        })

      });
      this.profileTabImg  = AppSettings.cdnUrl +"assets/images/user-bg.png";
      this.securityTabimg = AppSettings.cdnUrl+"assets/images/padlock-bg.png";
      this.gmatInfoImg = AppSettings.cdnUrl+"assets/images/exam-bg.png";
      this.formSuccessImg = AppSettings.cdnUrl+"assets/images/completed_user.png";


      this.route.params.subscribe(params => {
          this.tabActive = (params['tab']);
      });
  }


  ngOnInit()
  {
    this.getFullName();
    this.getUserPackages();
  }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"acount_info"}, this.userEmail);
  }
  getFullName() {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
      {
        this.fullName = data.firstName +' '+ data.lastName;
        this.userEmail = data.username;
        this.gcid = data.gmatClubId;
        this.linkedin = data.linkedIn;
        this.mediaPlayerDefaultQuality = data.mediaPlayerDefaultQuality;
        this.examType = data.examType;
        // this.examTypeOld = data.examType;
        this.targetScore = data.targetScore ? data.targetScore : '';
        this.targetVerbal= data.targetVerbalScore ? data.targetVerbalScore: '';
        this.targetQuant= data.targetQuantScore ? data.targetQuantScore: '' ;
        this.prevScore= data.previousScore ? data.previousScore: '';
        this.prevVerbal= data.previousVerbalScore ? data.previousVerbalScore: '';
        this.prevQuant= data.previousQuantScore ? data.previousQuantScore: '';
        this.tantativeDate = data.gmatDateTentative;
        this.testDate = data.gmatTestDate;
        this.gmatDataPresent = data.previousScore && this.examType === 'GCE' ? true : false;
        var coursesFullList = data.courseEnrollments.courseList;
        for(var i = 0; i < coursesFullList.length;i++)
        {
           this.couserObjectList = {};
           this.couserObjectList.courseID  = coursesFullList[i].courseID;
           this.couserObjectList.courseName  = coursesFullList[i].courseName;
           this.couserObjectList.startDate  = coursesFullList[i].startDate;
           this.couserObjectList.expiryDate  = coursesFullList[i].expiryDate;
           if(coursesFullList[i].status == "ENABLED")
           {
              var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
              var firstDate = new Date();
              var secondDate = new Date(coursesFullList[i].expiryDate);
              var dateDifference = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
              if(dateDifference < 15)
              {
                this.couserObjectList.status = "Expiring Soon";
                this.couserObjectList.statusImgURL = AppSettings.cdnUrl+ "assets/images/warning.png";
                this.couserObjectList.color = "#5fa406";
              }
              else
              {
                this.couserObjectList.status = "Active";
                this.couserObjectList.statusImgURL = AppSettings.cdnUrl+"assets/images/act.png";
                this.couserObjectList.color = "#5fa406";
              }
           }
           else if (coursesFullList[i].status == "DISABLED")
           {
               this.couserObjectList.status = "Expired";
               this.couserObjectList.statusImgURL = AppSettings.cdnUrl+"assets/images/expired.png";
               this.couserObjectList.color = "#5fa406";
           }
           this.courseList.push(this.couserObjectList);

        }
        this.dataLoaded = false;
         if(this.userEmail)
         {
            this.fireAccessedEvent();
         }
      }
    }
    );
  }
  getUserPackages()
  {
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/package/subscription', headers)
      .subscribe(
      (data) => {
        this.userCourseSubscription = data;
        this.userCourseSubscription = this.userCourseSubscription.map((item)=>{
          item['status'] = "Active";
          item['statusImgURL'] = AppSettings.cdnUrl+"assets/images/act.png";;
          item['color'] = "#5fa406";
          return item;
        })
        this.subscriptionDataLoaded = true;
      });
  }
  validateSpecialCharacters(event:any)
  {
    if(event.keyCode < 48 || event.keyCode > 57)
    {
      return false;
    }
  }
  validateTotal(scoreError:any, event:any)
  {
    var score = event.target.value;
    if(score == "" || score == null)
    {
      this.formError = false;
      scoreError.style.display = "none";
    }
    else if(score>800 || score<200)
    {
      scoreError.innerHTML = "Enter a valid score between 200 and 800"
      scoreError.style.display = "block";
      this.formError = true;
    }
    else if(score%10 != 0)
    {

      scoreError.innerHTML = "Score should be multiple of 10 between 200 and 800"
      scoreError.style.display = "block";
      this.formError = true;
    }
    else
    {
      scoreError.style.display = "none";
      this.formError = false;
    }
    this.checkActiveError();
  }


  validateSingle(scoreError:any, event:any)
  {
    var score = event.target.value;
    if(score == "" || score == null)
    {
      this.formError = false;
      scoreError.style.display = "none";
    }
    else if(score>51 || score<6)
    {
      scoreError.style.display = "block";
      scoreError.innerHTML = "Enter a valid score between 6 and 51";
      this.formError = true;
    }
    else if(!Number.isInteger(Number(score)))
    {
      scoreError.style.display = "block";
      scoreError.innerHTML = "Score is an integer between 6 and 51";
      this.formError = true;
    }
    else
    {
      scoreError.style.display = "none";
      this.formError = false;
    }
    this.checkActiveError();
  }

  checkActiveError()
  {
    var errorLine = <HTMLCollection>document.getElementsByClassName("score_error");
    for(let i=0; i< errorLine.length;i++)
    {
      if((<HTMLElement>errorLine[i]).style.display == "block")
      {
        this.formError = true;
      }
    }
  }
  toggle(tabName:String, event)
  {
      this.tabActive = tabName;
      this.location.go('/user/account-info/'+tabName);

      if(tabName == "gmat-info"){
          let headers = new HttpHeaders();

          this.httpClientService.get(AppSettings.restApiUrl +
                '/api/user/gmatScores', headers)
            .subscribe((data) =>
            {
              this.populateValueInFields(data);
            },(e)=>{

            });
       }
  }

  populateValueInFields(data:any){
      if(data.id != -1){

          this.gmatDataPresent = data.currentGMATScore != 0 && this.examType === 'GCE' ? true : false;

          this.prevScore = data.currentGMATScore != 0 ? data.currentGMATScore : null;
          this.prevQuant = data.currentQuantScore != 0 ? data.currentQuantScore : null;
          this.prevVerbal = data.currentVerbalScore != 0 ? data.currentVerbalScore : null;
          this.targetQuant = data.targetQuantScore != 0 ? data.targetQuantScore : null;
          this.targetVerbal = data.targetVerbalScore != 0 ? data.targetVerbalScore : null;
          this.targetScore = data.targetGMATScore != 0 ? data.targetGMATScore : null;
          this.testDate = data.mockTestDate != null ? data.mockTestDate : null;
          this.tantativeDate = data.id == 1 ? true : false;
      }
      else{
          this.emptyInputFields();
          this.gmatDataPresent = false;
    }
  }
  emptyInputFields(){
        this.prevScore = null;
        this.prevQuant = null;
        this.prevVerbal = null;
        this.targetScore = null;
        this.targetQuant = null;
        this.targetVerbal = null;
        this.testDate = null;
        this.tantativeDate = false;
  }

  updateUser()
  {
     var fullname = this.profileForm.value.fullname.trim().split(' ');
     var fname = '';
     var lname = '';
     if(fullname.length == 1)
      {
          fname = fullname[0];
      }
      else if(fullname.length > 1)
      {
          fname = fullname[0];
          lname = fullname[1];
      }
     var userDetails = {"firstName":fname, "lastName":lname,
                        "gmatClubId":this.profileForm.value.gcid,
                        "linkedIn":this.profileForm.value.lnkid,
                        "mediaPlayerDefaultQuality": this.mediaPlayerDefaultQuality,
                        "examType": this.examType
                      };

      let headers = new HttpHeaders();
      this.httpClientService.post(AppSettings.restApiUrl + '/api/user/details', userDetails, headers)
      .subscribe(
      (data) => {
        // if(this.examTypeOld != this.examType){
        //   push_event_properties('GMAT Exam Type Selected',{'Exam_Type':this.examType});
        // }
        this.success_msg= true;
        this.gmatDataPresent = this.examType === 'GCE';
        this.sessionService.updateuserInfo(1);
        setTimeout(() =>{
          this.success_msg= false;
        },1500);
      }
      );
  }

  updateUserGMATInfo()
  {
      let gmatDate = new Date(this.gmatForm.value.testdate.epoc*1000);
      let date = new Date(gmatDate.getTime() + Math.abs(gmatDate.getTimezoneOffset()*60000));
      var userGMATInfo = { "gmatTestDate":date,
                            "gmatDateTentative": this.tantativeDate,
                            "targetScore":this.targetScore,
                            "targetVerbalScore":this.targetVerbal,
                            "targetQuantScore":this.targetQuant,
                            "previousScore":this.prevScore,
                            "previousVerbalScore":this.prevVerbal,
                            "previousQuantScore":this.prevQuant
                          };
        this.fireEnteredGmatDateEvent();
        let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + '/api/user/gmatInfo', userGMATInfo, headers)
      .subscribe(
      (data) => {
        this.success_msg_gmat= true;
        setTimeout(() =>{
          this.success_msg_gmat= false;
        },1500);
      }
      );
  }

  fireEnteredGmatDateEvent()
    {
      let gmatDate = this.gmatForm.value.testdate['date'];
      let eventName = "entered gmat date";
      let timestamp = new Date(gmatDate['year'],gmatDate['month']-1,gmatDate['day']).getTime();
      let computed_properties = {
                                  "egd_name":this.fullName,
                                  "egd_gmatdate_mp":new Date(gmatDate['year'],gmatDate['month']-1,gmatDate['day']).toISOString(),
                                  "egd_gmatdate":(gmatDate['month'])+'/'+gmatDate['day']+'/'+gmatDate['year'],
                                  "egd_timestamp":timestamp,
                                  "source_name" :"profile_page",
                                  "tentative date":this.tantativeDate
                                    };
      this.eventService.track(eventName,computed_properties);
    }

   checkPassword()
   {
     if(this.isNotSameError == true)
     {
         if(this.securityForm.value.newpwd != this.securityForm.value.cnfpwd)
         {
             this.isNotSameError = true ;
         }
         else
         {
             this.isNotSameError = false;
         }
     }
   }

  updateUserPassword()
  {
      var userPasswords = {
                            "currentPassword":this.securityForm.value.crpwd,
                            "password": this.securityForm.value.newpwd,
                            "passwordAgain":this.securityForm.value.cnfpwd
                          }
      if(/\s/.test(userPasswords.password))
      {
        this.invalidStringError = true;
        this.isNotSameError = false;
        this.minCharacterError = false;
        return;
      }
      else if(userPasswords.password.length <6)
      {
        this.minCharacterError = true;
        this.invalidStringError = false;
        this.isNotSameError = false;
        return;
      }
      if(userPasswords.password != userPasswords.passwordAgain)
      {
        this.isNotSameError = true;
        this.minCharacterError = false;
        this.invalidStringError = false;
        return;
      }
      else
      {
      let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + '/api/user/changePassword', userPasswords, headers)
      .subscribe(
      (data) => {
        this.success_msg_pwd= true;
        this.incorrectPassword = false;
        setTimeout(() =>{
          this.success_msg_pwd= false;
        },1500);
      },(e)=>{

          if(e.status == 400)
          {
              if(e.message == "Password incorrect")
              {
                  this.incorrectPassword = true;
                  this.isNotSameError = false;
              }
              else
               {
                 this.isNotSameError = true;
                 this.incorrectPassword = false;
               }
          }
      }
      );
      }
  }

  @HostListener('unloaded')
  ngOnDestroy()
  {
      this.userInfoSubscription.unsubscribe();
  }

}
